/**
 * Owner/Proprietario Navigation
 * Navigation for condo owners - limited to their own unit and condo
 */

import { NavGroup } from './types';

export const OWNER_NAVIGATION: NavGroup[] = [
  {
    group: 'Minha Unidade',
    icon: 'Home',
    items: [
      { name: 'Moradores', href: '/residents', icon: 'Users' },
      { name: 'Visitantes', href: '/visitors', icon: 'UserCheck' },
    ],
  },
  {
    group: 'Condomínio',
    icon: 'Building2',
    items: [
      { name: 'Informações', href: '/condo-info', icon: 'Building2' },
      { name: 'Avisos', href: '/notices', icon: 'Bell' },
    ],
  },
  {
    group: 'Ajuda',
    icon: 'HelpCircle',
    items: [
      { name: 'Central de Ajuda', href: '/support', icon: 'Book' },
    ],
  },
];
